/**
 * Detects mobile devices via user agent string.
 * Unlike the viewport-based `isMobile` store, this checks for actual device type
 * (e.g., to disable forced HLS where native mobile playback is preferred).
 */
export const isMobileDevice =
    typeof navigator !== 'undefined' && /iPad|iPhone|iPod|Android/i.test(navigator.userAgent);
